import React, { useEffect, useState } from "react";
import * as s from "./index.module.scss";
import Link from "next/link";
import { IoArrowForward } from "react-icons/io5";
import CustomerService from "../../../images/AboutMB/customer-service-inverse.svg";
import secondaryFont from "@/utils/secondaryFont";
import { PrismicRichText } from "@prismicio/react";

const ContactMB = ({
  title = "About Manhattan Buyers",
  text = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
  call = false,
  data = {},
  title_fw_style,
}) => {
  const tell = data?.mobile_number || "";
  let desc = "";
  let descText = false;

  if (call) {
    desc = data?.contact_us_description;
    descText = true;
  } else {
    desc = data?.about_mb_description;
    descText = true;
  }

  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section className={`section-center ${s.contact_mb}`}>
      <div className={s.contact_mb_wrapper}>
        <article>
          <img
            src={
              // call && windowWidth < 580 ? data?.contact_us_mobile_image?.url || ""
              call && windowWidth < 1024
                ? data?.contact_us_tab_image?.url || ""
                : call && windowWidth < 1400
                  ? data?.contact_us_desktop_image?.url || ""
                  : call && windowWidth >= 1400
                    ? data?.contact_us_large_desktop_image?.url || ""
                    : ""
            }
            alt={data?.contact_us_desktop_image?.alt || "image"}
            loading="lazy"
          />
        </article>
        <article className={s.article_content}>
          <h3 className={title_fw_style}>
            {call
              ? data?.contact_us_title || ""
              : data?.about_mb_title || title}
          </h3>
          {descText ? (
            <div className={`${secondaryFont} title`}>
              <PrismicRichText field={desc || []} />
            </div>
          ) : (
            <p className={`${secondaryFont} title`}>{text}</p>
          )}
          {!call && (
            <Link
              href={data?.about_mb_view_more_link || ""}
              className={`btn btn-outline-dark ${secondaryFont}`}
            >
              View More{" "}
              <IoArrowForward size="18px" style={{ marginLeft: "8px" }} />
            </Link>
          )}
          {call && (
            <a
              href={`tel:${data?.mobile_number ? data.mobile_number.replace(/\s/g, "") : ""}`}
              className={s.speak_with_expert}
            >
              <div>
                <img src={CustomerService.src} alt="image" loading="lazy" />
              </div>
              <div>
                <p className={secondaryFont}>
                  Speak with an
                  <span> expert</span>
                </p>
                <div>
                  <span className={secondaryFont}>
                    {data?.mobile_number || ""}
                  </span>
                </div>
              </div>
            </a>
          )}
        </article>
      </div>
    </section>
  );
};

export default ContactMB;
